/** Maximum number of observations per competency category.
 *  Sourced from etraining.observation joined to observation_category for
 *  ts_1 and ets_3 form types. ets_3 adds ASE/INS/IWT/MLE on top of the
 *  shared set.
 */
export const CATEGORY_TOTALS: Readonly<Record<string, number>> = {
	FPA: 6,
	KNO: 7,
	PRO: 7,
	FPM: 7,
	SAW: 7,
	WLM: 9,
	PSD: 9,
	COM: 10,
	LTW: 11,
	ASE: 11,
	INS: 12,
	IWT: 9,
	MLE: 9,
};
